import { useQuery } from "@tanstack/react-query";
import { useDataProvider } from "ra-core";
import { useCallback } from "react";

import { sinLasQueFaltan } from "../dominio/etapas";
import type { Etapa } from "../dominio/tipos";
import type { NevoraDataProvider } from "./dataProvider";

/**
 * Filtro de las etapas que la base aún no tiene (34, «Esperando info del cliente», 19/10/2026):
 * el tablero, la ficha y el alta no las enseñan hasta que la migración esté aplicada. Se pregunta
 * una vez por sesión; mientras se sabe, las nuevas no salen.
 */
export const useFiltroEtapas = (): ((lista: Etapa[]) => Etapa[]) => {
  const dataProvider = useDataProvider<NevoraDataProvider>();
  const { data } = useQuery({
    queryKey: ["nevora", "etapasNuevasEnLaBase"],
    queryFn: () => dataProvider.etapasNuevasEnLaBase(),
    staleTime: Infinity,
    retry: false,
  });
  return useCallback((lista: Etapa[]) => sinLasQueFaltan(lista, data), [data]);
};

/**
 * ¿La base ya tiene el paquete de la 36 (etapa «No show», «Mis comisiones»…)? Misma consulta que
 * el filtro de etapas; false mientras se sabe.
 */
export const useCon36 = (): boolean => {
  const dataProvider = useDataProvider<NevoraDataProvider>();
  const { data } = useQuery({
    queryKey: ["nevora", "etapasNuevasEnLaBase"],
    queryFn: () => dataProvider.etapasNuevasEnLaBase(),
    staleTime: Infinity,
    retry: false,
  });
  return !!data?.includes("no_show");
};
